import { render, staticRenderFns } from "./apexchart.vue?vue&type=template&id=567d2c38&scoped=true&"
import script from "./apexchart.vue?vue&type=script&lang=js&"
export * from "./apexchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d2c38",
  null
  
)

export default component.exports